<template>
  <div class="container-fluid new_Header">
    <div class="row">
      <div class="col-12 space">
        <nav class="nav_Breadcrumb">
          <ol class="breadcrumb lawyerbreadcrumb">
            <li class="breadcrumb-item mx-2">
              <router-link  to="/">{{$t("lawyerRequested.breadcrumb_1")}}</router-link>
            </li>
            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
            <li class="mx-2 breadcrumb-title">
              <router-link to="/propertiecreate">
                {{$t("nav.realEstateServices")}}
              </router-link>
            </li>
            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
            <li class="active mx-2 almarai-bold" aria-current="page">
              {{$t("lawyerRequested.breadcrumb_2")}}
            </li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <div class="container pt-3">
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber='errorNumber' />
    <div class="row pt-3 justify-content-center" v-if="step == 1">
      <div class="col-12 col-md-6 d-block d-lg-none text-center">
        <img src="/assets/images/lawer-mobile.png" class="max-500" alt="">
      </div>
      <div class="col-12 col-md-6">
        <div class="row justify-content-center">
          <div class="col-12">
            <div class="card border-0">
              <div class="card-body">
                <form action="">
                  <!-- <div class="row justify-content-center">
                    <div class="col-auto tex-center">
                      <img src="/assets/images/lawyerLogo.jpeg" class="header-logo" alt="">
                    </div>
                  </div> -->
                  <div class="row">
                    <div class="col position-R">
                      <label for="" class="p-content">⁠
                        <span>{{$t("lawyerRequested.fullName")}}</span>
                        <span class="stars">*</span>
                      </label>
                      <input type="text" v-model="fullName" :placeholder="$t('lawyerRequested.enter_Fullname')" 
                        class="form-control input-style inputPadding" maxlength="50" @keypress="charsOnly"
                      >
                      <img src="/assets/images/icons/profile.png" class="max-24 userIcon" alt="">
                    </div>
                    <div class="error-feedback red-color fonttext-14" v-if="validate.fullName.$error">
                      {{ validateMessage }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col position-R">
                      <label for="" class="p-content">
                        <span>{{$t('lawyerRequested.phoneNumber')}}</span>
                        <span class="stars">*</span>
                      </label>
                      <input type="text" v-model="mobile" :placeholder="$t('lawyerRequested.enterPhoneNumber')" 
                        class="form-control input-style inputPadding" maxlength="10" @input="mobile = mobile.replace(/[^0-9]/g, '')"
                      >
                      <img src="/assets/images/icons/mobile.png" class="max-20 userIcon" alt="">
                    </div>
                    <div class="error-feedback red-color fonttext-14" v-if="validate.mobile.$error">
                      {{ validateMessage }}
                    </div>
                  </div>

                  <div class="row pt-2" v-if="price">
                    <div class="col position-R">
                      <label class="fonttext-14 gray-color">{{$t('maintenances.title_9')}}</label>
                      <input type="text" id="discount" class="form-control input-style" v-model="discount">
                      <span class="discount" @click.prevent="checkDiscount">{{$t('maintenances.title_10')}}</span>
                    </div>
                  </div>

                  <div class="row pt-2">
                    <div class="col">
                      <label class="p-content" for="">
                        <span>{{$t('lawyerRequested.consultationDescription')}}</span>
                        <span class="stars">*</span>
                      </label>
                      <textarea rows="6" class="form-control input-style" :placeholder="$t('lawyerRequested.detailsInquiry')" v-model="description"></textarea>
                    </div>
                    <div class="error-feedback red-color fonttext-14" v-if="validate.description.$error">
                      {{ validateMessage }}
                    </div>
                  </div>

                  <div class="row pt-3">
                    <div class="col-12">
                      <label class="p-content">{{$t('lawyerRequested.attachDocuments')}}</label>
                      <div class="uploadFile">
                        <label class="mouse-hand" for="upload" >
                          <img src="/assets/images/icons/file-up.png" class="max-28 py-2"  alt=""> <br>
                          <input type="file" id="upload" @change="uploadFile($event.target.files)" 
                            class="input-style d-none form-control" multiple accept="image/*,application/pdf"
                          >
                          <div class="font-color-3E font-12">{{$t('addAd.certifiedDocument')}}</div>
                          <div class="font-color-AB py-2">{{$t('addAd.supported_Fileformats')}}</div>
                        </label>
                      </div>
                    </div>
                  </div>

                  <div class="row pt-4 justify-content-center">
                    <div v-if="isLoading">
                      <loader />
                    </div>
                    <div v-else class="col-10 col-md-6 mouse-hand" @click="paymentMethod">
                      <div class="btn-green">{{$t('lawyerRequested.Submitrequest')}}</div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 d-none d-lg-block text-center">
        <img src="/assets/images/lawyer-Image.png" class="max-500" alt="">
      </div>
    </div>

    <!--begin:form success-->
    <div class="row" v-if="step == 2">
      <div class="col">
        <div class="row">
          <div class="col text-center">
            <div><img src="/assets/images/icons/tick-circle-gold.png" class="circleGold" alt=""></div>
          </div>
        </div>
        <div class="row pt-4">
          <div class="col text-center">
            <h4 class="almarai-bold">{{$t('lawyerRequested.successfullySubmitted')}}</h4>
          </div>
        </div>

        <div class="row py-4 justify-content-center">
          <div class="col-9 col-md-4">
            <router-link to="/">
              <button class="btn-green form-control">{{$t('formSuccess.title_4')}}</button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <!--end:form success-->

    <!-- begin:modal-payment -->
    <button type="button"  id="documentPayment" class="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#documentModal">
      </button>
    <div class="modal fade" id="documentModal" tabindex="-1" aria-labelledby="documentModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <!-- <div class="modal-header border-0 pb-1">
            <h1 class="modal-title fs-5 pt-2" id="documentModalLabel">{{$t('wallet.title_12')}}</h1>
            <button type="button" id="closeModal" class="btn-close p-3 m-0" data-bs-dismiss="modal" aria-label="Close"></button>
          </div> -->
          
          <div class="modal-body">
            <div class="row py-2">
              <div class="col almarai-bold">
                {{$t('wallet.payment')}}
              </div>
              <div class="col-auto mouse-hand" data-bs-dismiss="modal" aria-label="Close">
                <i class="fa-regular fa-circle-xmark fs-5 gray-color"></i>
              </div>
            </div>

            <div class="py-2 gray-color">{{$t('wallet.choosePayment_Method')}}</div>

            <div class="row py-3" v-if="price">
              <label class="almarai-bold mb-2">{{$t('wallet.cost')}}</label>
              <div class="col-12">
                <div class="d-flex input-style">
                  <span class="gray-color almarai-bold">{{$t('wallet.cost')}}</span>
                  <div class="direction">
                    <span class="mx-2 gray-color almarai-bold">{{price}}</span>
                    <span>
                      <img src="/assets/images/icons/riyal.png" class="max-16" alt="">
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <label class="almarai-bold pt-2">{{$t('wallet.title_13')}}</label>
            <div class="row pt-3 justify-content-center">
              <div class="col-12 position-R">
                <label for="visa" class=" mouse-hand d-block">
                  <div :class="(paymentGate == 'online')? 'wallet-style priceList' : 'wallet-style'">
                    <input class="form-check-input radio-left select_Radio" v-model="paymentGate" type="radio" value="online" name="radioDefault" id="visa">
                    <img src="/assets/images/icons/bank.png" class="width-icon" alt="">
                    <span class="mx-2 almarai-bold">{{$t('wallet.title_14')}}</span>
                    <span class="bankCard">{{$t('wallet.bankCard')}}</span>
                  </div>
                </label>
              </div>
            </div>

            <div class="row pt-3 justify-content-center">
              <div class="col-12 position-R">
                <label for="radioDefault1" class=" mouse-hand d-block">
                  <div :class="(paymentGate == 'wallet')? 'wallet-style priceList' : 'wallet-style'">
                    <input class="form-check-input radio-left select_Radio" v-model="paymentGate"  value="wallet" type="radio"  name="radioDefault" id="radioDefault1">
                    <img src="/assets/images/icons/wallet-3.png" class="width-icon" alt="">
                    <span class="mx-2 almarai-bold">{{$t('wallet.title_16')}}</span>
                    <span class="bankCard">{{$t('wallet.appWallet')}}</span>
                  </div>
                </label>
              </div>
            </div>

            <div class="row pt-3 justify-content-center">
              <loader v-if="paymentLoading" class="text-center" />
              <div v-else class="col-11 col-md-8 text-center">
                <div @click.prevent="paymentSelected" class="form-control almarai-bold btn-green">{{$t('maintenanceDetails.title_5')}} </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end:modal-payment -->

    <!--begin:popup wallet balance -->
    <button type="button"  id="popup_Wallet" class="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#popup_WalletBalance">
      </button>
    <div class="modal bg-color-B d-none" tabindex="-1" id="popup_WalletBalance">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header headerWallet">
            <button type="button" class="btn-close m-0" id="closeWalletBalance" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <h6 class="modal-title text-center almarai-bold pt-3">{{$t('walletPaymentConfirmation')}}</h6>
          <div class="modal-body">
            <div class="row" v-if="paymentGate == 'wallet'">
              <div class="col-auto almarai-bold content-center">{{$t('walletBalance')}}</div>
              <div class="col text-direction">
                {{USER_WALLET_BALANCE}}
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
              </div>
            </div>

            <div class="row" v-if="newDiscount === null">
              <div class="col-auto almarai-bold content-center">{{$t('totalOrder')}}</div>
              <div class="col text-start">
                {{price}}
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
              </div>
            </div>

            <div class="row" v-if="newDiscount !== null">
              <div class="col-auto almarai-bold content-center">{{$t('totalOrder')}}</div>
              <div class="col text-start">
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
                <del>{{price}}</del>
              </div>
            </div>

            <div class="row" v-if="newDiscount !== null || discountPercentage">
              <div class="col-auto almarai-bold content-center">{{$t('priceDiscount')}}</div>
              <div class="col text-start">
                {{newDiscount}}
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
              </div>
            </div>

            <div class="row" v-if="paymentGate == 'wallet'">
              <div class="col-auto almarai-bold content-center">{{$t('remainingBalance')}}</div>
              <div class="col text-direction">
                {{remainingBalance}}
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
              </div>
            </div>

            <div class="row justify-content-center pt-3">
              <div v-if="min_loader" class="text-center">
                <loader />
              </div>
              <div v-else class="col-12 col-md-6 text-center" @click.prevent="createLawyerRequest">
                <div class="btn-green">{{$t('confirmButton')}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end:popup wallet balance -->

    <!--begin:Charge your wallet -->
    <div class="modal bg-color-B" tabindex="-1" id="chargeWallet">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header headerWallet">
            <button type="button" class="btn-close m-0" @click="closePopupCharge" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <h6 class="modal-title text-center almarai-bold pt-3">{{$t('balanceInsufficient')}}</h6>
          <div class="modal-body">
            <div class="row justify-content-center">
              <div class="col text-center">
                <div class="small-Font">{{$t('chargeWallet')}}</div>
              </div>
            </div>

            <div class="row pt-3 justify-content-center">
              <div class="col text-center">
                <router-link to="/wallet">
                  <div class="btn-green fonttext-14">{{$t('btnChargeWallet')}}</div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end:Charge your wallet -->

    <!-- Modal:begin couponPopup -->
    <button type="button" id="coupon" class="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#exampleModal">
    </button>
    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content br-radius-24">
          <div class="modal-body text-center">
            <div><img src="/assets/images/icons/new-success.png" class="w-25" alt=""></div>
            <h6 v-if="value" class="pt-3"><span class="ms-1">{{$t('maintenances.title_9')}}</span> {{value.amount}} {{(value.discountType == "percentage" )? '%' : $t('maintenances.title_22') }}</h6>
            <p>{{$t('maintenances.title_20')}}</p>
            <div class="row justify-content-center">
              <div class="col-12 col-md-8">
                <div type="button" class="btn-green" data-bs-dismiss="modal">{{$t('maintenances.title_21')}}</div>
              </div>
            </div>
          </div>            
        </div>
      </div>
    </div>
    <!-- end:couponPopup -->

  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { mapGetters } from 'vuex';
export default {
  name: 'lawyerRequested',

  setup(){
    return { validate: useVuelidate() }
  },

  data(){
    return{
      propertyType: this.$route.query.propertyType,
      propertyId: this.$route.params.id,
      hasError: false,
      message: '',
      errorNumber: null,
      isLoading: false,
      fullName: '',
      mobile: '',
      description: '',
      step: 1,
      validateMessage: this.$t('validateMessage'),
      userLang: 'ar',
      isFree: null,
      paymentGate: "",
      price: 0,
      remainingBalance: null,
      min_loader: false,
      paymentLoading: false,
      attachDocuments: [],
      discount: null,
      newDiscount: null,
      discountPercentage: null,
      value: {},
    }
  },
  validations (){
    return {
      fullName: {required},
      mobile: {required},
      description: {required},
      
    }
  },

  computed:{
    ...mapGetters(['USER_WALLET_BALANCE'])
  },

  methods:{
    async createLawyerRequest(){
      this.hasError = false;
      this.isLoading = true;
      this.min_loader = true;
      const formData = new FormData();
      formData.append('name', this.fullName);
      formData.append('mobile', this.mobile);
      formData.append('subject', this.description);
      formData.append('paymentGate', this.paymentGate);
      if(this.propertyType && this.propertyId){
        formData.append('propertyType', this.propertyType);
        formData.append('propertyId', parseInt(this.propertyId));
      }

      if(this.attachDocuments && this.attachDocuments.length){
        for(let file =0; file < this.attachDocuments.length; file++){
          formData.append('attachments',this.attachDocuments[file]);
        }
      }
      if(this.discount){
        formData.append('coupon', this.discount);
      }

      await this.$http.post('/api/lawyerReq/create', formData).then(res => {
        // console.log(res);
        if(res.data.paymentUrl){
          window.location.href = res.data.paymentUrl;
        }else{
          const confirmDiv = document.getElementById('popup_WalletBalance');
          if(confirmDiv && confirmDiv.style.display == 'block'){
            document.getElementById('closeWalletBalance').click();
          }
          this.closePopupCharge();
          this.step = 2;
          window.scrollTo({top:0, behavior: 'smooth'});

          if(this.paymentGate == 'wallet')
            this.$store.dispatch('checkUser');
        }
        this.isLoading = false;
        this.min_loader = false;
      }).catch(err => {
        // console.log(err);
        this.isLoading = false;
        this.min_loader = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        document.getElementById('closeWalletBalance').click();
        window.scrollTo({top:0, behavior: 'smooth'});
      });
    },

    async paymentMethod(){
      const valid = await this.validate.$validate();
      if(!valid){
        window.scrollTo({top:0, behavior: 'smooth'});
        return false;
      }
      if(!this.mobile.startsWith('05') || this.mobile.trim().length != 10){
        this.message = this.$t('incorrectMobile');
        this.hasError = true;
        window.scrollTo({top:0, behavior:'smooth'});
        return false;
      }

      if(!this.price || (this.value.discountType == 'percentage' && this.value.amount == 100)){
        this.createLawyerRequest();
        return false;
      }

      if(this.isFree){
        this.createLawyerRequest();
      }else{
        document.getElementById('documentPayment').click();
      }
    },
    

    charsOnly(e) {
      // keep only Arabic letters, Latin letters, and spaces
      // requires modern JS regex support for Unicode property escapes
      const char = e.key;
      const allowed = /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FFA-Za-z\s]$/;

      if (!allowed.test(char)) {
        e.preventDefault(); // block the input
      }
    },

    getPrice(){
      this.$http.post('/api/lawyerReq/init',{
        propertyId: this.propertyId,
        propertyType: this.propertyType,
      }).then(res => {
        // console.log(res);
        this.price = res.data.price;
        this.isFree = res.data.isFree;
      }).catch(err => {
        this.isLoading = false;
        this.min_loader = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      });
    },

    paymentSelected(){
      this.paymentLoading = true;
      if(this.paymentGate == 'online'){
        this.createLawyerRequest();
      }else {
        this.paymentLoading = false;
        document.getElementById('documentPayment').click();
        if(this.price > this.USER_WALLET_BALANCE){
          document.getElementById('chargeWallet').style.display = 'block';
        }else{
          this.remainingBalance =  this.USER_WALLET_BALANCE - this.price;
          document.getElementById('popup_Wallet').click();
        }
      }
    },

    closePopupCharge(){
      document.getElementById('chargeWallet').style.display = 'none';
    },

    uploadFile(files) {
      this.attachDocuments = [...files];
    },

    checkDiscount(){
      this.hasError = false;
      this.$http.post("/api/coupons/available",{
        coupon: this.discount,
        modelName: 'lawyer',
      }).then(res => {
        // console.log(res);
        this.value = res.data.row;
        document.getElementById('coupon').click();
        if(this.value.discountType == 'percentage'){
          this.newDiscount = this.price - ((this.price * this.value.amount) /100);
          this.remainingBalance = parseFloat(this.USER_WALLET_BALANCE) - parseFloat(this.newDiscount);
        }else{
          this.newDiscount = this.price - this.value.amount;
          this.remainingBalance = parseFloat(this.USER_WALLET_BALANCE) - parseFloat(this.newDiscount);
        }
      }).catch(err => {
        // console.log(err);
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      });
    },

  },
  created(){
    this.userLang = localStorage.getItem('lang') ?? 'ar';
    window.scrollTo({top:0, behavior: 'smooth'})
    this.getPrice();
    // setTimeout(()=> {
    //   document.getElementById('chargeWallet').style.display = 'block';
    // },1200)
  },
}
</script>